export const cardProps = {
  props: {
    parentGeneral: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};

export const cardComputed = {
  computed: {
    cardElVarStyles() {
      const { corners } = this.parentGeneral;

      let borderRadius = "var(--card-border-radius-round)";

      if (corners.value === "square") {
        borderRadius = "var(--card-border-radius-square)";
      } else if (corners.value === "round") {
        borderRadius = "var(--card-border-radius-round)";
      }

      return { borderRadius };
    },
    cardElStyles() {
      const { cardBackgroundColor } = this.parentGeneral;

      const styles = {
        backgroundColor: cardBackgroundColor.value,
      };

      return styles;
    },
  },
};
